import { render, staticRenderFns } from "./LicenseUpload.vue?vue&type=template&id=b54e010a&scoped=true"
import script from "./LicenseUpload.vue?vue&type=script&lang=js"
export * from "./LicenseUpload.vue?vue&type=script&lang=js"
import style0 from "./LicenseUpload.vue?vue&type=style&index=0&id=b54e010a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54e010a",
  null
  
)

export default component.exports